<template>
  <section class="price-section">
    <div class="wrapper">
      <div class="options-section" v-if="products">
        <h2 class="options-title">{{ $t("Additional items are available after purchasing the Island.") }}</h2>
        <p class="options-subtitle">{{ $t("Price") }}</p>

        <div class="options-grid">
          <div
            v-for="(item, i) in products.slice(0, 8)"
            :key="i"
            class="option-card-wrapper"
          >
            <OptionCard :item="item" :currency="currency" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import OptionCard from "./OptionCard.vue";

export default {
  name: "SectionFour",
  components: { OptionCard },
  props: {
    isAuth: Boolean,
    currency: String,
    products: {
      type: Array,
      default: () => [],
    },
  },
};
</script>

<style lang="scss" scoped>
.price-section {
  margin-top: 9px;
}

.price-header {
  margin-bottom: 64px;
}

.price-title {
  font-size: 128px;
  font-weight: 900;
  line-height: 161px;
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 24px;
}

.price-subtitle {
  font-size: 32px;
  font-weight: 200;
  line-height: 40px;
  text-align: center;
  color: #a1d6f4;
}

.island-cards {
  display: flex;
  flex-wrap: wrap;
  gap: 95px 24px;
  justify-content: center;
  align-items: flex-start;
}

.island-card-wrapper {
  // width: 100%;
}

.option-card-wrapper {
  // width: 100%;
}

.options-section {
  margin-top: 192px;
  margin-bottom: 205px;
  text-align: center;
}

.options-title {
  font-size: 64px;
  font-weight: 700;
  line-height: 96px;
}

.options-subtitle {
  font-size: 20px;
  font-weight: 500;
  line-height: 30px;
  color: #fff;
}

.options-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
  margin-top: 30px;
}

@media (max-width: 1400px) {
  .options-title {
    color: #0b2535;
  }
  .options-subtitle {
    color: #0b2535;
  }
}
@media (max-width: 1280px) {
  .island-cards {
    justify-content: center;
  }

  .price-title {
    font-size: 96px;
    line-height: 120px;
  }
}

@media (max-width: 768px) {
  .price-title {
    font-size: 64px;
    line-height: 80px;
  }
  .options-section {
    margin-top: 40px;
    margin-bottom: 60px;
  }
  .island-cards {
  }

  .island-card-wrapper {
    width: 100%;
    max-width: 393px;
    margin: 0 auto;
  }

  .options-grid {
    gap: 24px 16px;
  }
}
</style>
